import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const HeatmapIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props} viewBox="0 0 28 28">
        <path
            stroke="currentColor"
            strokeWidth={0.8}
            fill="none"
            d="M5.5 15.5v-9a2 2 0 012-2h6m-8 11v5a2 2 0 002 2h6m-8-7h8m0-11h8a2 2 0 012 2v6m-10-8v8m0 10v-7m0 7h5m-5-7v-3m0 0h5m5 0v5m0-5h-5m0 0v5m0 5h3a2 2 0 002-2v-3m-5 5v-5m0 0h5"
        />
    </SvgIcon>
)

export default HeatmapIcon
